// extracted by mini-css-extract-plugin
module.exports = {"section":"Spacer_section__Szwlx"};